module.exports = __webpack_public_path__ + "static/media/file-contract-dollar.f2b21ddb.svg";